import { useCallback, useEffect, useState } from 'react';

//import { useAcsItems } from '../../providers/AcsItems';

export type CalculatorVehicle = {
	'@Type'?: string;
	'CalcInfos'?: string;
	'HSN'?: string;
	'ID': string;
	'Key'?: string;
	'Mileage': string;
	'Options'?: { Option: Array<Record<string, string>> };
	'PreviousUsage'?: VwfsPreuse;
	'PriceModel': string;
	'PriceOriginal': string;
	'PriceTotal': string;
	'RegNumber'?: string;
	'VehicleId'?: string;
	'CarlineKey'?: string;
	'SalesgroupKey'?: string;
	'RegDateFirst'?: string;
	'ResidualValueReductionPercent'?: string;
	'TSN'?: string;
	'Year'?: string;
};

export type VwfsPreuse =
	| `Taxi`
	| `RentalCar`
	| `DrivingSchool`
	| `Leasing`
	| `OneYearOld`
	| `CompanyCarAudi`
	| `CompanyCarVW`
	| `OneDayRegistration`
	| `Demonstrator`
	| `PlantCompanyCar`;

export type CalculatorSummaryProduct = {
	id?: string;
	default?: boolean;
	description?: string;
	group?: string;
	label?: string;
	type?: string;
};

export type CalculatorProductParameter = {
	'@ID': string;
	'#text': string;
	'@Changed'?: boolean;
};

export type CalculatorProduct = {
	'@ID'?: string;
	'@CampaignID'?: string;
	'Parameter'?: CalculatorProductParameter[];
};

export type CalculatorRequest = {
	Request: {
		'@Domain': string;
		'Dealer'?: unknown;
		'Product'?: CalculatorProduct;
		'Vehicle': unknown;
	};
};

export type CalculatorDefaultProduct = { toRaw(): CalculatorProduct };

export type CalculatorResponseSummaries = {
	ContainedProducts?: { Product: Array<{ Text?: string }> };
	DownPayment?: string;
	Duration?: string;
	EffectiveInterestRate?: string;
	GuaranteedBuyBackPrice?: string;
	InstallmentGrossAmount?: string;
	Mileage?: string;
	NetLoanAmount?: string;
	NominalInterestRate?: string;
	ProductId?: string;
	StaticCosts?: { DistributionAmount: { GrossAmount?: string } };
	TotalAmount?: string;
};

export type CalculatorResponseCalculation = {
	DetailGroups?: Array<{
		Description?: string;
		Detail?: Array<CalculatorDetail>;
		Disclaimer?: string;
		Id: string;
		Label?: string;
	}>;
	Disclaimer?: string;
	Title?: string;
	Type?: string;
};

export type CalculatorDetail = {
	Emphasize?: boolean;
	Id: string;
	Label: string;
	Note: string;
	Units: { Value: string; Symbol: string };
	Value: string;
	ValueUnitText?: string;
};

export type CalculatorResponseTracking = {
	AdditionalParameters: Array<unknown> | null;
	AdditionalProducts: Array<unknown> | null;
	Financing: {
		CashPrice: string | null;
		Currency: string | null;
		DownPayment: { Percentage: string | null; Value: string | null };
		Duration: string | null;
		FinalPayment: string | null;
		Interest: { Dept: string | null; Effective: string | null };
		Mileage: { Number: string | null; Unit: string | null };
		MonthlyPayment: string | null;
		TotalSum: string | null;
	};
	Product: { Name: string | null; Type: string | null; Usage: string | null };
};

export type CalculatorDefaultResponse = {
	rawResponse: {
		Response?: {
			Calculation?: CalculatorResponseSummaries;
			Parameters?: {
				CalculationDisclaimer?: string;
				Description?: string;
				GlobalDisclaimer?: string;
			};
			Result?: {
				CalculationDisclaimer?: string;
				Domain?: string;
				GlobalDisclaimer?: string;
				Summaries?: { Summary: CalculatorResponseSummaries[] };
			};
		};
	};
};

export type CalculatorFormatedSummaries = {
	Full: CalculatorFormatedDetail;
	RateOnly: CalculatorDetail;
	Sparse: CalculatorFormatedDetail;
};

export type CalculatorFormatedDetail = {
	Bonusfinancing?: CalculatorDetail;
	DownPayment?: CalculatorDetail;
	Duration?: CalculatorDetail;
	FinalRate?: CalculatorDetail;
	InterestRateNominal?: CalculatorDetail;
	Kilometers?: CalculatorDetail;
	NetCreditAmount?: CalculatorDetail;
	Rate?: CalculatorDetail;
	TAE?: CalculatorDetail;
	TotalAmount?: CalculatorDetail;
	TotalAmountFinanced?: CalculatorDetail;
};

export type CalculatorProductsResponse = {
	checksum: string | undefined;
	culture: string | undefined;
	domain: string | undefined;
	products: { default: string | undefined };
};

export interface CalculatorClass {
	new (options?: { CRS_URL?: string }): Calculator;
}

export interface Calculator {
	getProductsAsync(
		props: CalculatorRequest | string,
	): Promise<CalculatorProductsResponse>;
	getDefaultsAsync(
		props: CalculatorRequest | string,
	): Promise<CalculatorDefaultResponse>;
	getDefaultSummary(
		props: CalculatorRequest | string,
		options: {
			ResultContainer?: HTMLDivElement;
			Summary?: {
				Type: string;
				ResultContainer: HTMLDivElement;
				Layout?: string;
			};
			Callback?: (a: unknown, b: unknown) => void;
		},
	): Promise<void>;
	getInterface(
		props: CalculatorRequest | string,
		options: {
			ResultContainer?: HTMLDivElement;
			// LayoutConfig?: {
			// 	LeftColumnRatio?: string;
			// 	RightColumnRatio?: string;
			// 	MultiColumn?: boolean;
			// 	IncludeLabelParameters?: boolean;
			// 	Sections?: {
			// 		Header?: {
			// 			visible: boolean;
			// 		};
			// 		ProductSelection?: {
			// 			visible: boolean;
			// 		};
			// 		Parameters?: {
			// 			visible: boolean;
			// 		};
			// 		Summary?: {
			// 			visible: boolean;
			// 		};
			// 		Buttons?: {
			// 			visible: boolean;
			// 		};
			// 		Disclaimers?: {
			// 			visible: boolean;
			// 		};
			// 	};
			// };

			Layout?: string;
			Summary?: { Type: string };
			// PreventProductsRequest?: boolean;
			// ProductDescriptionAsInfoIcon?: boolean;
			AutoPostback?: boolean;
			// ContainerStyle?: {
			// 	padding: string;
			// };
			// FatalErrorOnChangeMessage?: string;
			// FatalErrorMessage?: string;
			// HeaderImageUrl?: string;
			// MarkdownText?: boolean;
			FullInterface?: boolean;
			CalculateButton?: string;
			ApplyButton?: string;
			ApplyButtonFunction?: (params: Record<string, unknown>) => void;
			ResponseCallback?: (defaultsResponse: unknown, productId: string) => void;
		},
	): Promise<void>;
	getDefaultProductForVehicleAsync(
		props: CalculatorRequest | string,
	): Promise<CalculatorDefaultProduct>;

	getConcurrentRateAsync(
		request: CalculatorRequest | string,
		options?: Record<string, unknown>,
	): Promise<unknown>;
}

declare global {
	interface Window {
		Calculator?: CalculatorClass;
	}
}

export type CalculatorResult =
	| { readonly status: 'loading' }
	| { readonly status: 'ready'; readonly calculator: Calculator }
	| { readonly status: 'error'; readonly error: unknown };

/**
 * This is intended to be called exactly once by the Calculator context
 * provider. Any other component/hook should use the context instead, to
 * retrieve the shared Calculator instance.
 */
export function useCalculator(): CalculatorResult | undefined {
	const acsTest = {
		hasRates: true,
		services: {
			calculatorService: {
				vwfs: { newCar: `VW.NEW` },
				calculator: {
					crsUrl: `https://api.webcalc.vwfs.io/webcalc-frontend-service`,
					excludeCampaignIdFromProduct: true,
					scriptUrl: `https://cdn.fts.webcalc.vwfs.io/2-latest/bronson-bundled/calculator.js`,
					styleUrl: `https://cdn.bronson.vwfs.io/vw6/v/14.2.0/css/style.scoped.min.css`,
				},
			},
		},
	};

	const {
		hasRates,
		services: {
			calculatorService: {
				calculator: { crsUrl, scriptUrl, styleUrl },
			},
		},
	} = acsTest;

	/*
	const {
		hasRates,
		services: {
			calculatorService: {
				calculator: { crsUrl, scriptUrl, styleUrl },
			},
		},
	} = useAcsItems();
	*/

	const createReadyResult = useCallback(
		(Calculator: CalculatorClass): CalculatorResult => ({
			status: `ready`,
			calculator: new Calculator({ CRS_URL: crsUrl }),
		}),
		[crsUrl],
	);

	const [result, setResult] = useState<CalculatorResult | undefined>(() => {
		if (!hasRates) {
			return undefined;
		}

		if (window.Calculator === undefined) {
			return { status: `loading` };
		}

		return createReadyResult(window.Calculator);
	});

	useEffect(() => {
		if (result?.status !== `loading`) {
			return;
		}

		if (window.Calculator !== undefined) {
			setResult(createReadyResult(window.Calculator));

			return;
		}

		const abortController = new AbortController();

		const loadJsAndCss = () => {
			const script = document.createElement(`script`);

			script.src = scriptUrl;
			script.defer = true;

			script.addEventListener(
				`error`,
				(error) => {
					setResult({ status: `error`, error: error.error });
				},
				{ signal: abortController.signal },
			);

			script.addEventListener(
				`load`,
				() => {
					if (window.Calculator === undefined) {
						setResult({
							status: `error`,
							error: new Error(
								`Could not find global Calculator after loading ${scriptUrl}.`,
							),
						});
					} else {
						setResult(createReadyResult(window.Calculator));
					}
				},
				{ signal: abortController.signal },
			);

			document.head.append(script);

			const link = document.createElement(`link`);

			link.href = styleUrl;
			link.rel = `stylesheet`;
			link.type = `text/css`;

			document.head.append(link);
		};

		let idleCallbackId: number | undefined;

		if (`requestIdleCallback` in window) {
			idleCallbackId = window.requestIdleCallback(loadJsAndCss);
		} else {
			loadJsAndCss();
		}

		return () => {
			if (idleCallbackId) {
				window.cancelIdleCallback(idleCallbackId);
			}

			abortController.abort();
		};
		// The URLs are static, so we only need to trigger this on mount, and only
		// if the initial result status is 'loading'.
	}, []);

	return result;
}
